/** Validadores sem dependências, partilhados pelos fluxos de cadastro da vertical Beleza. */
export const minutosHorario = (value) => {
  if (typeof value !== 'string' || !/^\d{2}:\d{2}(?::\d{2})?$/.test(value)) return null;
  const [h, m] = value.split(':').map(Number);
  return h < 24 && m < 60 ? h * 60 + m : null;
};

/** Retorna uma mensagem de erro ou null. Não altera os intervalos recebidos. */
export const validarGradeSemanal = (grade) => {
  if (!Array.isArray(grade)) return 'A grade semanal deve ser uma lista.';
  if (grade.length > 70) return 'A grade semanal excedeu o máximo de 70 intervalos.';
  const porDia = new Map();
  for (const item of grade) {
    if (item?.ativo === false) continue;
    const dia = Number(item?.diaSemana);
    if (!Number.isInteger(dia) || dia < 0 || dia > 6) return 'Há um dia da semana inválido.';
    const ini = minutosHorario(item?.horaInicio);
    const fim = minutosHorario(item?.horaFim);
    if (ini === null || fim === null || ini >= fim) return 'O início de cada turno deve anteceder o fim.';
    const temInicio = item?.intervaloInicio !== undefined && item?.intervaloInicio !== null && item?.intervaloInicio !== '';
    const temFim = item?.intervaloFim !== undefined && item?.intervaloFim !== null && item?.intervaloFim !== '';
    if (temInicio !== temFim) return 'Informe início e fim da pausa ou deixe ambos vazios.';
    if (temInicio) {
      const pausaInicio = minutosHorario(item.intervaloInicio);
      const pausaFim = minutosHorario(item.intervaloFim);
      if (pausaInicio === null || pausaFim === null || pausaInicio < ini || pausaFim > fim || pausaInicio >= pausaFim)
        return 'A pausa deve estar integralmente dentro do turno e ter duração positiva.';
    }
    const turnos = porDia.get(dia) || [];
    turnos.push({ ini, fim });
    porDia.set(dia, turnos);
  }
  for (const [dia, turnos] of porDia) {
    turnos.sort((a, b) => a.ini - b.ini);
    if (turnos.some((turno, i) => i > 0 && turno.ini < turnos[i - 1].fim))
      return `Existem turnos sobrepostos em ${['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'][dia]}.`;
  }
  return null;
};
